"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const utilitycheckmarkfilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 64 66",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-utilitycheckmarkfilled` : '') + (description ? ` desc-utilitycheckmarkfilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-utilitycheckmarkfilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-utilitycheckmarkfilled"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M61 32.95c0 16.5-12.98 29.87-29 29.87-16 0-29-13.37-29-29.87S15.98 3.1 32 3.1c16 0 29 13.36 29 29.85Z",
    fill: "#207E15"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 3.1v59.7c-7.5 0-15.03-2.98-20.5-8.75a30.87 30.87 0 0 1-8.45-21.1 30.2 30.2 0 0 1 8.9-21.54c5.78-5.7 12.6-8.43 20.05-8.33Z",
    fill: "#207E15"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.35 41.7c-.32.08-.38-.1-.57-.3-1.55-1.63-3.97-6.36-5.74-7.2-3.36-1.57-6.34 2.02-4.45 5.4.92 1.65 7.05 9.99 8.3 11.03 1.85 1.56 4.61.85 6.05-.99 2.22-2.83 5.28-9.28 7.04-12.72 1.38-2.69 2.66-5.45 3.95-8.19.4-.86.94-1.7 1.33-2.55.62-1.35 2.37-4.83 2.63-6.01.94-4.22-4.27-6.59-6.58-2.88-.7 1.14-1.3 2.57-1.93 3.79-.39.76-.74 1.58-1.13 2.35a854.9 854.9 0 0 0-8.9 18.26v.01Z",
    fill: "#CCFFDA"
  }));
};
var _default = exports.default = utilitycheckmarkfilled;